<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}"
      class="dimmed_black" style="top:0;display:block;"></div>
    <!--popup 시작-->
    <div :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big" id="pop_cancelAro" style="display:block;">
      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">정기구매 장바구니 선택</span>
          <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
        </h2>
      </div>
      <div class="rew19_popup_cont" :class="{cartAddDialog: aroInfo.rawData.master_list && aroInfo.rawData.master_list.length > 3}">
        <div class="rew19_centerMsg">
          고객님은 이미 정기구매를 이용 중입니다.<br/>
          신규 정기구매 장바구니를 만드시겠습니까?<br/>
          또는 기존 정기구매 약정에 상품만 추가할 수 있습니다. 
        </div>
        <h3 class="rew19_third_title">신규 정기구매</h3>
        <ul class="rew19_underline_list">
          <li class="type1">
            <div class="rew19_wrapRadio_t1">
              <input type="radio" class="rew19_fakeRadio_t1" id="fakeRadio_1_1"
                v-model="aroInfo.resData.addTo" :value="'CART'">
              <label for="fakeRadio_1_1">신규 정기구매 장바구니에 담기</label>
            </div>
          </li>
        </ul>

        
        <h3 class="rew19_third_title">기존 정기구매에 상품 추가</h3>

        <div v-show="showAgelocMiCustumProductWarning" 
          class="rew19_messageBox" style="margin-top:20px;margin-bottom:20px;">
          <p class="rew19_txtcenter">
            에이지락 미 커스텀 프로덕트 세트는 <br/>
            MY PAGE -> 나의 정기구매 -> 정기구매 자세히 -> 주문상품 변경을 통해 추가 부탁드립니다.
          </p>
        </div>

        <ul v-show="!showAgelocMiCustumProductWarning" class="rew19_underline_list">
          <li class="type1"
            v-for="(aroMaster) in aroInfo.rawData.master_list" v-bind:key="aroMaster.aro_no">
            <div class="rew19_wrapRadio_t1">
              <input type="radio" class="rew19_fakeRadio_t1"
                v-model="aroInfo.resData.addTo" :value="aroMaster.aro_no" :id="'fakeRadio_'+aroMaster.aro_no">
              <label :for="'fakeRadio_'+aroMaster.aro_no">
                정기구매 번호 {{aroMaster.aro_no}} ({{aroMaster.payment_count}}회차, {{$fmt.WON(aroMaster.payment_amt)}}원) – {{aroMaster.aroTag}}
              </label>
            </div>
          </li>          
        </ul>

        <page-nav v-show="!showAgelocMiCustumProductWarning"
          ref="pageNav"
          :totalItemCount="aroInfo.rawData.totalCount"
          :pageNo="aroInfo.rawData.page"
          :itemCountPerPage="aroInfo.rawData.countPerPage"
          :pageGroup="5"
          @onClickPage="onClickPage"
        ></page-nav>
      </div><!--//rew19_popup_cont-->

      <div class="rew19_popup_btn rew19_clear">
          <button class="rew19_popHarf disabled" @click="onCancel">취소</button>
          <button class="rew19_popHarf activation" @click="onOk">확인</button>
      </div>
    </div>  
  </div>  
</template>
<script>
import * as ErrMsg from "@/utils/error_msg";
import PageNav from "@/components/paging/pageNav";
import * as Const from "@/utils/const";

const DEFAULT_ARO_INFO = {
  rawData : {
    countPerPage: 5,
    page: 1,
    totalCount: 0, 
    //...
  },  
  resData : {
    addTo : "CART", //장바구니:CART, aro_no:기존Aro에 추가
    aroData : null,
  }      
}

export default {
  name: 'CartAddDialog',
  components: { PageNav },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {      
      currentZIndex : 2000,

      showAgelocMiCustumProductWarning : false,

      aroInfo : DEFAULT_ARO_INFO,      
    }
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);
      
      show && this.$nextTick(() => {
        let _this = this;
        _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

        this.$el.focus();
      })
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102); 
    })
  },
  mounted() {
    let _this = this;
  },  
  methods :{
    onClose(response) {
      let _this = this;
      const defaultSelect = {
        addTo : "CART", aroData : null
      }

      if(response){
        let aroDatas = _this.aroInfo.rawData.master_list.filter(item=>{
            return _this.aroInfo.resData.addTo === item.aro_no;
        });

        if(aroDatas.length > 0){
          let selected = aroDatas[0];
          _this.aroInfo.resData.addTo = selected.aro_no;
          _this.aroInfo.resData.aroData = selected;
        }else{
          _this.aroInfo.resData = defaultSelect;
        }
      }else{
        _this.aroInfo.resData = defaultSelect;
      }
      _this.$emit('close', response, _this.aroInfo);
    },
    onCancel(){
      this.onClose(false);
    },
    onOk() {
      this.onClose(true);
    },

    /**
     * API Request
     */    
    //나의 ARO 정보 가져오기
    apiGetAro : function(pageNo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_aro`, {
        params: {
          isUspan : "N",
          page : pageNo,
          countPerPage : _this.aroInfo.rawData.countPerPage
        }        
      });
    },

    /**
     * Local 
     */
    initData : function(){
      let _this = this;

      _this.aroInfo = JSON.parse(JSON.stringify(_this.data));
      _this.aroInfo = {...DEFAULT_ARO_INFO, ..._this.aroInfo};      

      _this.showAgelocMiCustumProductWarning = false;
      if(Const.ARO_SKINCARE_PRODUCT_ID == _this.data.targetProduct.pd_id ){
        //'에이지락미 커스텀 프로덕트' 의 경우 상세 설정이 필요하여,
        //나의 ARO에서 직접 추가하도록 안내

        _this.showAgelocMiCustumProductWarning = true;
        
      }else{
        if(!(_this.aroInfo.rawData.totalCount && _this.aroInfo.rawData.totalCount > 0)){
          _this.loadData();
        }

        //Pass Paging info
        _this.$refs.pageNav.resetVal(
          _this.aroInfo.rawData.totalCount,
          _this.aroInfo.rawData.page,
          _this.aroInfo.rawData.countPerPage,
        );
      }
    },

    loadData : function(reqPageNo){
      let _this = this;

      let sc = _this.aroInfo.sc;
      
      _this.$showLoading();      
      _this.apiGetAro(reqPageNo).then(res=>{        
        
        if (res.status === 200 && res.data.status === "0000") {
          _this.aroInfo.rawData = res.data;
          //Pass Paging info
          _this.$refs.pageNav.resetVal(
            _this.aroInfo.rawData.totalCount,
            _this.aroInfo.rawData.page,
            _this.aroInfo.rawData.countPerPage,
          );
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }
      }).catch((err)=>{        
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    onClickPage(pageNo){
      let _this = this;

      _this.loadData(pageNo);
    }
  }
}
</script>
<style>
@media only screen and (min-width: 769px) {
  .rew19_popContainer.big .rew19_popup_cont.cartAddDialog {
    height: 630px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/CartAddDialog.vue